// extracted by mini-css-extract-plugin
export default {"user-form":"style_user-form__U8-zf","user-form-wrapper":"style_user-form-wrapper__NtHjr","field":"style_field__wg6Cy"};